import React from "react";
import { StyleSheet, Text, View } from "react-native";

import OnboardingBaseScreen from "./Components/OnboardingBaseScreen";

import type { AppUserSession } from "@/schemas/auth/session";
import { Spacings } from "@/styling/spacings";
import PhysicalAttributes from "@/Components/PersonalAttributes/PhysicalAttributes";
import { AttributeCardDisplayVariantType } from "@/Components/PersonalAttributes/types";
import NoteCard from "@/Components/Cards/NoteCard";

type Props = {
  session: AppUserSession;
};

function OnboardingPhysicalAttributesScreen({
  session,
}: Props): React.JSX.Element {
  const stageMainComponent: React.JSX.Element = (
    <View style={styles.sectionContainer}>
      <Text style={styles.sectionTitle}>{"Physical Attributes"}</Text>
      <NoteCard
        text="Sharing your physical attributes enables more accurate filters and
          improves our matching algorithm to help you find meaningful
          connections."
      />
      <PhysicalAttributes
        session={session}
        attributes={{}}
        variant={AttributeCardDisplayVariantType.ONBOARDING}
      />
    </View>
  );

  return (
    <OnboardingBaseScreen
      session={session}
      title={"Build Your Profile"}
      subtitle="Let's get your profile set up so you can start meeting amazing
          people."
      canContinue={true}
      stageMainComponent={stageMainComponent}
    />
  );
}

const styles = StyleSheet.create({
  sectionContainer: {
    flexDirection: "column",
    alignItems: "center",
    marginHorizontal: Spacings.s3,
    marginBottom: Spacings.s3,
    flex: 1,
  },
  sectionTitle: {
    fontSize: 20,
    marginBottom: Spacings.s3,
    fontWeight: "bold",
  },
});

export default OnboardingPhysicalAttributesScreen;
